import React, { Component } from "react";
import CobrandsTable from "../../components/cobrandselection/CobrandsTable";
import Search from "../../components/Search";

class Cobrands extends Component {
  state = {
    cobrands: [],
    searchTerm: "",
    rowsPerPage: 50
  };

  componentDidMount() {
    this.setState({
      cobrands: JSON.parse(localStorage.getItem("userData")).cobrands
    });
  }

  handleChange = e => {
    this.setState({ searchTerm: e.target.value });
  };

  render() {
    const filteredCobrands = [
      ...this.state.cobrands.filter(
        cobrand =>
          cobrand.name
            .toLowerCase()
            .indexOf(this.state.searchTerm.toLowerCase()) !== -1 ||
          cobrand.id.toString().indexOf(this.state.searchTerm) !== -1
      )
    ];
    return (
      <div className="container main">
        <div className="heading mt-4">Select Cobrand</div>
        <div className="row mt-2 mb-4 d-flex justify-content-start">
          <div className="col-md-4">
            <Search
              searchTerm={this.handleChange}
              placeholder="Search by Cobrand ID, Cobrand Name"
            />
          </div>
        </div>
        <CobrandsTable
          data={filteredCobrands}
          paginationPerPage={this.state.rowsPerPage}
        />
      </div>
    );
  }
}

export default Cobrands;
